import { Avatar } from '@mui/material';
import { memo, useEffect, useState } from 'react';
import { getAbsoluteFileUrl, renderFullName } from '../helpers/utils';

const StaffAvatar = ({ staff, type = 'doc', ...props }) => {
  const [url, setUrl] = useState(null);
  const [name, setName] = useState(null);

  useEffect(() => {
    // Define a default URL based on staff?.staffFileUrl
    let newUrl = getAbsoluteFileUrl(staff?.staffFileUrl);

    // Check the type and update the URL accordingly
    if (type === 'doc') {
      // Use staff?.staffFileUrl for 'doc'
      if (staff?.staffFileUrl) {
        newUrl = getAbsoluteFileUrl(staff?.staffFileUrl);
      }
      if (staff?.photo && staff?.photo.length) {
        newUrl = getAbsoluteFileUrl(staff.photo);
      }
    } else if (type === 'avatar') {
      if (staff?.staffFileUrl) {
        newUrl = getAbsoluteFileUrl(staff?.staffFileUrl);
      }
      if (staff?.applicationUserImageFileUrl) {
        newUrl = getAbsoluteFileUrl(staff.applicationUserImageFileUrl);
      }
      if (staff?.photo && staff?.photo.length) {
        newUrl = getAbsoluteFileUrl(staff.photo);
      }
    }

    // Set the URL
    setUrl(newUrl);
  }, [type, staff]);
  useEffect(() => {
    let fullName = renderFullName(staff);
    if (staff?.name) {
      setName(
        staff.name
          .split(' ')
          .slice(0, 2)
          .map((name) => name[0])
          .join('')
      );
    } else if (fullName && fullName.length) {
      fullName = fullName
        .split(' ')
        .slice(0, 2)
        .map((name) => name[0])
        .join('');
      setName(fullName);
    }
  }, [staff, type]);
  return (
    <Avatar src={url} alt={name} title={name} {...props}>
      {name || null}
    </Avatar>
  );
};

export default memo(StaffAvatar);
